<template>
  <div class="geo-zones-component screen">
    <SheetVehicleFeatureHeader title="Geo zones" :hasVehiclePicker="false" v-if="$isMobile" />
    <div class="header-band" v-else>
      <VehicleModalMenu @close="beforeClose()" />
      <span class="title">Geo zones</span>
      <Tooltip class="ns-tooltip" @click.native="showTooltip" />
      <CloseButton inline @click="beforeClose()" />
    </div>
    <Alert />
    <div class="panel">
      <SmoothReflow>
        <div>
          <div class="buttons justify-content-end mb-4" v-if="!loading">
            <button class="btn btn-outline create-btn mr-3" @click="createAlert">Create alert</button>
            <button class="btn btn-outline create-btn" @click="createZone">Create zone</button>
          </div>
          <template v-if="geoZones.length || loading">
            <PanelSpinner v-if="loading" />
            <div class="intro" v-if="geoZones.length">Use the toggle switch below to view your active Geo Zones on the map.</div>
            <div class="item container" v-for="(item, i) in geoZones" :key="item.Id">
              <div class="row align-items-center text-left">
                <div class="col-6 col-lg-8">
                  <span class="name">{{ item.Name }}</span>
                </div>
                <!-- <div class="col-6 col-lg-3">
                  <span class="shape">{{ JSON.parse(item.EditorMetadata).Shape }}</span>
                </div> -->
                <div class="col-6 col-lg-4 d-flex justify-content-around">
                  <div class="divider"></div>
                  <div class="custom-control custom-switch">
                    <input
                      type="checkbox"
                      class="custom-control-input"
                      :id="'alertActive' + i"
                      v-model="item.showOnMap"
                      :disabled="processing"
                      @click="toggleDisplay(item.Id)"
                    />
                    <label class="custom-control-label" :for="'alertActive' + i" />
                  </div>
                  <img src="~@/assets/images/edit.svg" class="button" width="25" height="25" alt @click="edit(item)" />
                  <div class="d-flex align-items-center">
                    <Spinner v-if="processing && deletedGeoZoneId === item.Id" />
                    <svg v-else xmlns="http://www.w3.org/2000/svg" width="13.836" height="13.837" viewBox="0 0 13.836 13.837" class="delete-icon button" fill="currentColor" @click="deleteGeoZone(item.Id)">
                      <g id="Group_4063" data-name="Group 4063" transform="translate(13.086 0.75) rotate(90)">
                        <path id="Path_8639" data-name="Path 8639" d="M-5614.277,57.633a.748.748,0,0,1-.53-.22.75.75,0,0,1,0-1.061l12.337-12.336a.75.75,0,0,1,1.061,0,.75.75,0,0,1,0,1.061l-12.337,12.336A.748.748,0,0,1-5614.277,57.633Z" transform="translate(5614.277 -44.547)" fill="#140047"/>
                        <path id="Path_8640" data-name="Path 8640" d="M-5601.94,57.633a.748.748,0,0,1-.53-.22l-12.337-12.336a.75.75,0,0,1,0-1.061.75.75,0,0,1,1.061,0l12.337,12.336a.75.75,0,0,1,0,1.061A.748.748,0,0,1-5601.94,57.633Z" transform="translate(5614.277 -44.547)" fill="#140047"/>
                      </g>
                    </svg>
                  </div>
                </div>
              </div>
            </div>
          </template>
          <div class="message-box" v-else>
            <div class="icon">
              <img src="~@/assets/images/globe.svg" width="22" height="22" />
            </div>
            You have not created any zones yet.
          </div>
        </div>
      </SmoothReflow>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import "~@/assets/scss/variables.scss";

.geo-zones-component {
  .header-band {
    display: flex;
    align-items: center;
    background-color: #fff;
    padding: 12px 30px;
    margin: -10px -30px 25px -30px;
    color: $brand-color-1;
    position: relative;
    font-size: 1.1875rem;

    .title {
      font-weight: 600;
      color: $brand-color-1;
      margin-left: 5px;
    }

    .ns-tooltip {
      margin-left: auto;
      margin-right: 10px;
    }

    /deep/ .close-button {
      margin-left: 0;
    }

    /deep/ .menu__link {
      color: $brand-color-1;
    }

    /deep/ .menu-button .icon {
      fill: $brand-color-1;
    }

  }

  .panel {
    background: $brand-color-4;
    padding: 1.5rem;

    .buttons {
      display: flex;
    }

    .create-btn {
      min-width: 92px;
      font-size: 14px;
    }

    .intro {
      margin-bottom: 20px;
    }

    .item {
      background: #fff;
      padding-top: 10px;
      padding-bottom: 10px;
      margin-bottom: 15px;
      box-shadow: $drop-shadow-light;

      &:last-of-type {
        margin-bottom: 0;
      }

      .name {
        font-weight: 600;
      }

      .shape {
        text-transform: capitalize;
      }

      .delete-icon {
        fill: $brand-color-1;
      }

      .divider {
        width: 1px;
        height: 25px;
        background-color: $brand-color-3;
      }

      .custom-switch {
        .custom-control-label::before {
          background-color: $brand-color-2;
          border-color: $brand-color-2;
        }

        .custom-control-label::after {
          background-color: #fff;
        }

        .custom-control-input:checked ~ .custom-control-label::before {
          background-color: $brand-color-2;
          border-color: $brand-color-2;
        }

        .custom-control-input:checked ~ .custom-control-label::after {
          background-color: #fff;
        }
      }

      .button {
        &:hover {
          cursor: pointer;
        }
      }
    }

    .message-box {
      background: #fff;
      position: relative;
      font-weight: 600;
      color: $brand-color-1;
      text-align: center;
      padding: 25px;
      margin-left: 0.5rem;
      border: 2px solid $brand-color-2;
      box-shadow: $drop-shadow-light;

      .icon {
        background: #fff;
        position: absolute;
        top: 50%;
        left: -17px;
        padding: 5px;
        transform: translateY(-50%);
        border-radius: 50%;
        border: 2px solid $brand-color-2;
      }
    }
  }
}
</style>

<script>
import {mapActions, mapGetters, mapMutations, mapState} from "vuex";
import { alertService, assetService, mapService, modalService, tooltipService } from "@/services";
import SheetVehicleFeatureHeader from "@/components/screens/SheetVehicleFeatureHeader";
import VehicleModalMenu from "@/components/screens/VehicleModalMenu";
import CloseButton from "@/components/CloseButton";
import Tooltip from "@/components/Tooltip";
import styles from "@/assets/scss/_variables.scss";

export default {
  name: "GeoZones",
  components: {
    SheetVehicleFeatureHeader,
    Tooltip,
    VehicleModalMenu,
    CloseButton,
  },
  data() {
    return {
      loading: true,
      processing: false,
      editing: false,
      geoZones: [],
      gmShapes: [],
      gmShapeOptions: {},
      deletedGeoZoneId: null,
    };
  },
  computed: {
    ...mapState(["map"]),
    ...mapState("navigation", ["showLeftDrawer"]),
    ...mapGetters("asset", ["getActiveSafeAndSoundVehicleId"]),
  },
  created() {
    const startTime = Date.now();
    assetService
      .getGeoZones()
      .then((data) => {
        const timeElapsed = Date.now() - startTime;
        setTimeout(
          () => {
            this.geoZones = data.map((item) => {
              item.showOnMap = false;
              return item;
            });
            this.loading = false;
            this.displayGeoZones();
          },
          timeElapsed < 500 ? 500 - timeElapsed : 0
        );
      })
      .catch((error) => {
        this.loading = false;
      });
  },
  mounted() {
    if (this.map.gmapRef) {
      this.gmShapeOptions = {
        fillColor: styles.brandColor2,
        fillOpacity: 0.2,
        strokeColor: styles.brandColor1,
        strokeOpacity: 1.0,
        strokeWeight: 4,
        editable: false,
        draggable: false,
        geodesic: true,
        map: this.map.gmapRef.$mapObject,
      };
    }
  },
  beforeDestroy() {
    if (this.editing) {
      this.resetGeoZoneDisplay();
    } else {
      this.resetMap();
    }
  },
  methods: {
    ...mapActions("map", ["openGeoZoneEditor", "setMapBounds"]),
    ...mapMutations("map", ["updateShowMarkers"]),
    beforeClose() {
      this.$emit("close");
    },
    showTooltip() {
      tooltipService.showTooltip("geo-zones");
    },
    resetMap() {
      this.resetGeoZoneDisplay();
      this.updateShowMarkers(true);
      this.setMapBounds();
    },
    createAlert() {
      modalService.showModal(this, "new-alert", {
        openedFromGeoZoneScreen: true,
        type: "Geo-Fencing",
      });
    },
    createZone() {
      this.editing = true;
      this.openGeoZoneEditor();
      this.beforeClose();
    },
    edit(geoZone) {
      this.editing = true;
      this.openGeoZoneEditor(geoZone);
      this.beforeClose();
    },
    toggleDisplay(geoZoneId) {
      this.geoZones.forEach((geoZone) => {
        if (geoZone.Id === geoZoneId) {
          geoZone.showOnMap = !geoZone.showOnMap;
        }
      });
      this.displayGeoZones();
    },
    deleteGeoZone(geoZoneId) {
      const vehicleId = this.getActiveSafeAndSoundVehicleId();
      assetService
          .getVehicleAlerts(vehicleId)
          .then((data) => {
            const alertsLinkedToGeoZones = data.filter(item =>
                item.EditorMetadata === "Geo-Fencing" &&
                item.Rules.length > 1 &&
                item.Rules[0].Value === geoZoneId.toString()
            );

            if (alertsLinkedToGeoZones.length) {
              modalService.showDeleteDialog("The selected Geo Zone is currently linked to an Alert. If you proceed with deleting the Geo Zone, the linked Alert will also be deleted.", () => {
                this.processing = true;
                this.deletedGeoZoneId = geoZoneId;
                const alertIds = alertsLinkedToGeoZones.map(item => item.Id);

                assetService
                    .deleteGeoZoneAndLinkedAlerts(alertIds, geoZoneId)
                    .then((result) => {
                      this.processing = false;
                      if (result) {
                        this.geoZones = this.geoZones.filter((item) => item.Id !== geoZoneId);
                        this.displayGeoZones();
                      } else {
                        alertService.showErrorAlert();
                      }
                      this.deletedGeoZoneId = null;
                    })
                    .catch((error) => {
                      this.processing = false;
                      this.deletedGeoZoneId = null;
                      alertService.showErrorAlert();
                    });
              });
            } else {
              modalService.showDeleteDialog("Are you sure you want to delete this geo zone?", () => {
                this.processing = true;
                this.deletedGeoZoneId = geoZoneId;
                assetService
                    .deleteGeoZone(geoZoneId)
                    .then((result) => {
                      this.processing = false;
                      if (result) {
                        this.geoZones = this.geoZones.filter((item) => item.Id !== geoZoneId);
                        this.displayGeoZones();
                      } else {
                        alertService.showErrorAlert();
                      }
                      this.deletedGeoZoneId = null;
                    })
                    .catch((error) => {
                      this.processing = false;
                      this.deletedGeoZoneId = null;
                      alertService.showErrorAlert();
                    });
              });
            }
          })
          .catch((error) => {
            this.processing = false;
            this.deletedGeoZoneId = null;
            alertService.showErrorAlert();
          });
    },
    displayGeoZones() {
      const geoZonesToDisplay = this.geoZones.filter((item) => item.showOnMap);
      if (geoZonesToDisplay.length) {
        this.resetGeoZoneDisplay();
        this.updateShowMarkers(false);
        const bounds = new google.maps.LatLngBounds();

        geoZonesToDisplay.forEach((geoZone) => {
          let gmShape = {};
          let gmShapeInfoWindow = "";
          const zoneString = geoZone.Zone;
          const geoData = mapService.getGeoData(zoneString);
          const color = JSON.parse(geoZone.EditorMetadata).Color;

          if (geoData.type === "Circle") {
            geoData.coordinates.forEach((coordinate) => {
              bounds.extend({ lat: coordinate[1], lng: coordinate[0] });
            });

            gmShape = new google.maps.Circle(
              Object.assign(this.gmShapeOptions, {
                fillColor: color,
                strokeColor: color,
                center: geoData.center,
                radius: geoData.radius,
              })
            );

            gmShapeInfoWindow = new google.maps.InfoWindow({
              position: gmShape.getCenter(),
              content: geoZone.Name,
              map: this.map.gmapRef.$mapObject,
            });

            this.saveShapeObject(gmShape, gmShapeInfoWindow);
          } else {
            const shapeBounds = new google.maps.LatLngBounds();
            const coordinates = [];

            if (geoData.type === "MultiPolygon") {
              geoData.coordinates.forEach((polygons) => {
                polygons.forEach((polygon) => {
                  polygon.forEach((coordinate) => {
                    const point = { lat: coordinate[1], lng: coordinate[0] };
                    bounds.extend(point);
                    shapeBounds.extend(point);
                    coordinates.push(point);
                  });
                });
              });
            } else {
              geoData.coordinates.forEach((shapes) => {
                shapes.forEach((coordinate) => {
                  const point = { lat: coordinate[1], lng: coordinate[0] };
                  bounds.extend(point);
                  shapeBounds.extend(point);
                  coordinates.push(point);
                });
              });
            }

            gmShape = new google.maps.Polygon(
              Object.assign(this.gmShapeOptions, {
                fillColor: color,
                strokeColor: color,
                paths: coordinates,
              })
            );

            gmShapeInfoWindow = new google.maps.InfoWindow({
              position: shapeBounds.getCenter(),
              content: geoZone.Name,
              map: this.map.gmapRef.$mapObject,
            });

            this.saveShapeObject(gmShape, gmShapeInfoWindow);
          }

          this.map.gmapRef.fitBounds(bounds);
        });
      } else {
        this.resetMap();
      }
    },
    resetGeoZoneDisplay() {
      if (this.gmShapes) {
        this.gmShapes.forEach((gmShape) => {
          gmShape.shape.setMap(null);
          gmShape.infoWindow.close();
        });
      }
    },
    saveShapeObject(shape, infoWindow) {
      this.gmShapes.push({
        shape: shape,
        infoWindow: infoWindow,
      });
    },
  },
  watch: {
    showLeftDrawer(value) {
      if (!value) {
        this.$destroy();
      }
    },
  },
};
</script>
